import { jsx as _jsx } from "react/jsx-runtime";
import { CatTooltip } from '@blocks-react/components/Tooltip';
export const MyEquipmentToolTip = ({ children, ...toolTipProps }) => {
    const onCloseTooltip = (e) => {
        e.stopPropagation();
    };
    return (_jsx(CatTooltip, { onBlTooltipClose: (e) => onCloseTooltip(e), onBlTooltipOpen: (e) => onCloseTooltip(e), ...toolTipProps, children: children }));
};
